import type { AnalyticsChart } from 'shared/domain/analytics/chartModel';
import { Brand, make } from 'shared/types/brand';

/** Key of a chart's saved filters: one per project and chart. */
export type ChartFiltersId = Brand<string, 'ChartFiltersId'>;

const asChartFiltersId = make<ChartFiltersId>();

export function toChartFiltersId(projectId: string, chart: AnalyticsChart): ChartFiltersId {
  return asChartFiltersId(`${projectId}_${chart}`);
}
